// extracted by mini-css-extract-plugin
export default {"card":"Card_card__D-z43","primary":"Card_primary__85krG","secondary":"Card_secondary__c35cS"};